import { BookingDetailService } from './booking-detail.service';
import { AppConstants } from './../../shared/constants/constants';
import { AppMessages } from './../../shared/constants/messages';
import { DialogService } from './../../shared/services/dialog.service';
import { Component, AfterViewInit, OnInit, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { FormLabelComponent } from '../../components/form/label/label.component';
import { FormMessageComponent } from '../../components/form/message/message.component';
import { ValidationService } from '../../shared/services/validation.service';
import { Utility } from '../../common/utility';
import { BookingDetailModel, BookingStatus } from '../../models/view-schedule/booking-detail.model';
import { MatInputModule, MatCheckboxModule, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';
import * as moment from 'moment';

@Component({
  selector: 'app-booking-detail',
  templateUrl: './booking-detail.component.html',
  providers: [BookingDetailService]
})
export class BookingDetailsPopupComponent implements OnInit, AfterViewInit {
  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtTrigger: Subject<any> = new Subject();

  public dataDetails = new BookingDetailModel();
  public appConstants = AppConstants;
  public dataclinicType = [];
  public bookingStatus = BookingStatus;
  public dataMembers = [];
  constructor(
    public utility: Utility,
    public dialogService: DialogService,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<BookingDetailsPopupComponent>,
    public bookingDetailService: BookingDetailService
  ) {
  }

  ngOnInit() {
    this.initData();
    this.bookingDetailService.getBookingDetail(this.data.id).subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.dataDetails = data;
          this.dataDetails.members.forEach(item => {
            this.dataMembers.push(item);
          });
          this.rerender();
        }
      }
    );

    this.dtOptions = {
      pagingType: 'full_numbers',
      paging: false,
      searching: false,
      retrieve: true,
      data: this.dataMembers,
      columns: [{
        title: 'Name',
        data: 'name'
      }, {
        title: 'DOB',
        data: 'dateOfBirth',
        render: function (data, type, row) {
          return moment(data.toString()).format('DD MMM YYYY');
        }
      }, {
        title: 'Address',
        data: 'address'
      }, {
        title: 'Phone',
        data: 'phone',
      }, {
        title: 'Email',
        data: 'email'
      }
      ],
      language: {
        emptyTable: 'No member record',
        info: 'Total _TOTAL_ member(s)',
        infoEmpty: 'Total 0 member(s)',
      }
    };
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  onCloseDialog(data) {
    this.dialogRef.close(data);
  }

  initData() {
  }

  onRemoveDetails() {
      this.dialogService.openConfirmationDialog({ message: AppMessages.bookingDetails.remove }).subscribe(
        (result) => {
          if (result) {
            this.bookingDetailService.removeBooking(this.data.id).subscribe(
              result1 => {
                if (result1) {
                  this.onCloseDialog(true);
                }
              }
            );
          }
        });
  }

  /**
   * for Rerender table
   */
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-schedule/booking-detail.component.ts